module.exports = __webpack_public_path__ + "static/media/anonymous.b6dcf4a4.svg";